module.exports = __webpack_public_path__ + "static/media/close_icon_dark_blue.4cbab4c1.png";